<template>
	<ul :class="[isMobile ? 'mobile-menu' : 'menu list-none display-inline']">
		<li>
			<router-link :to="{ name: 'about' }" :class="{ active: $route.path === '/chi-siamo' }" class="nav-main enabled">
				{{ $t('Menu.About') }}
			</router-link>
		</li>
		<li>
			<router-link
				:to="{ name: 'howToUser' }"
				:class="{ active: $route.path === '/come-funziona-utente' }"
				class="nav-main enabled"
			>
				{{ $t('Menu.HowTo') }}
			</router-link>
		</li>
		<li class="has-menu">
			<a :class="{ active: $route.path.indexOf('avvocati') !== -1 }" class="nav-main">
				{{ $t('Menu.Activities') }} <i v-if="!isMobile" class="fa fa-angle-down" aria-hidden="true"></i>
			</a>
			<ul class="has-menu with-grid">
				<li v-for="(value, key) in requestTypes" :key="key" class="grid-item">
					<div class="grid-icon">
						<span class="type-icon">
							<i class="fa" :class="value.icon" />
						</span>
					</div>
					<div class="grid-text">
						<a
							:href="'/avvocati/' + value.id"
							:class="{ active: $route.path === '/avvocati/' + value.id }"
							class="type-name"
						>
							{{ value.label }}
						</a>
					</div>
				</li>
			</ul>
		</li>
		<li>
			<router-link
				:to="{ name: 'storiesList' }"
				:class="{ active: $route.path === '/storie' }"
				class="nav-main enabled"
			>
				{{ $t('Menu.Stories') }}
			</router-link>
		</li>
		<li>
			<router-link
				:to="{ name: 'faqUser' }"
				:class="{ active: $route.path === '/faq-utente' }"
				class="nav-main enabled"
			>
				{{ $t('Menu.Faq') }}
			</router-link>
		</li>
		<li>
			<router-link :to="{ name: 'contacts' }" :class="{ active: $route.path === '/contatti' }" class="nav-main enabled">
				{{ $t('Menu.Contacts') }}
			</router-link>
		</li>
		<li v-if="!isLoggedIn">
			<router-link
				:to="{ name: 'registerUser' }"
				:class="{ active: $route.path === '/registrazione-utente' }"
				class="nav-main enabled"
			>
				{{ $t('Menu.Register') }}
			</router-link>
		</li>
		<li v-if="!isLoggedIn" class="has-menu">
			<a
				:class="{
					active:
						$route.path === '/registrazione-avvocato' ||
						$route.path === '/faq-avvocato' ||
						$route.path === '/come-funziona-avvocato',
				}"
				class="nav-main"
			>
				{{ $t('Menu.AreYouALawyer') }}? <i v-if="!isMobile" class="fa fa-angle-down" aria-hidden="true"></i>
			</a>
			<ul class="has-menu">
				<li>
					<router-link :to="{ name: 'faqLawyer' }" class="enabled" :class="{ active: $route.path === '/faq-avvocato' }">
						{{ $t('Menu.Faq') }}
					</router-link>
				</li>
				<li>
					<router-link
						:to="{ name: 'howToLawyer' }"
						class="enabled"
						:class="{ active: $route.path === '/come-funziona-avvocato' }"
					>
						{{ $t('Menu.HowTo') }}
					</router-link>
				</li>
				<li>
					<router-link
						:to="{ name: 'registerLawyer' }"
						class="enabled"
						:class="{ active: $route.path === '/registrazione-avvocato' }"
					>
						{{ $t('Menu.Register') }}
					</router-link>
				</li>
			</ul>
		</li>
		<li v-if="!isLoggedIn">
			<a
				class="nav-main enabled login-pop"
				:class="{ active: $route.path === '/login' }"
				@click.prevent="openLoginModal"
			>
				<i class="fa fa-sign-in" aria-hidden="true" />&nbsp;{{ $t('Menu.Login') }}
			</a>
		</li>
		<li v-if="isLoggedIn" class="has-menu">
			<a class="nav-main">
				{{ accountDisplayName }}
				<notification-badge />
				<i v-if="!isMobile" class="fa fa-angle-down" aria-hidden="true"></i>
			</a>
			<ul class="has-menu">
				<li>
					<router-link :to="{ name: 'dashboard' }" :class="{ enabled, active: $route.path === '/dashboard' }">
						{{ $t('Menu.Dashboard') }}
					</router-link>
				</li>
				<li v-if="isUserAccount">
					<router-link
						:to="{ name: 'requestCreateStep1' }"
						:class="{ enabled, active: $route.path.includes('/request/create') }"
					>
						{{ accountRequestText }}
					</router-link>
				</li>
				<li v-if="isUserAccount">
					<router-link :to="{ name: 'requestsList' }" :class="{ enabled, active: $route.path.includes('requests') }">
						{{ $t('Navigation.RequestsListUser') }}
					</router-link>
				</li>
				<li v-if="!isUserAccount">
					<router-link :to="{ name: 'responsesList' }" :class="{ enabled, active: $route.path === '/responses' }">
						{{ $t('Navigation.ResponsesListLawyer') }}
					</router-link>
				</li>
				<li>
					<router-link :to="{ name: 'messagesList' }" :class="{ enabled, active: $route.path === '/messages' }">
						{{ $t('Navigation.MessagesList') }}
					</router-link>
				</li>
				<li v-if="!isUserAccount">
					<router-link :to="{ name: 'requestsList' }" :class="{ enabled, active: $route.path === '/requests' }">
						{{ $t('Navigation.RequestsListLawyer') }}
					</router-link>
				</li>
				<li v-if="!isUserAccount">
					<router-link :to="{ name: 'feedbacksList' }" :class="{ enabled, active: $route.path === '/feedbacks' }">
						{{ $t('Navigation.FeedbacksList') }}
					</router-link>
				</li>
				<li v-if="!isUserAccount">
					<router-link :to="{ name: 'creditsList' }" :class="{ enabled, active: $route.path === '/credits' }">
						{{ $t('Navigation.CreditsList') }}
					</router-link>
				</li>
				<li>
					<router-link :to="{ name: 'profile' }" :class="{ enabled, active: $route.path === '/profile' }">
						{{ $t('Navigation.Profile') }}
						<span v-if="isAccountNotCompleted" class="incomplete-profile-mark">
							{{ $t('Misc.Incomplete') }} <i class="fa fa-exclamation-triangle"></i>
						</span>
					</router-link>
				</li>
				<li>
					<router-link :to="{ name: 'logout' }">
						{{ $t('Menu.Logout') }}&nbsp;
						<i class="fa fa-sign-out" aria-hidden="true"></i>
					</router-link>
				</li>
			</ul>
		</li>
	</ul>
</template>

<script>
import AccountInfo from '@/mixins/AccountInfo'
import ModalHelper from '@/mixins/ModalHelper'
import NotificationBadge from '@/components/notifications/NotificationBadge'
import ServiceHelper from '@/mixins/ServiceHelper'

export default {
	name: 'HeaderNavigation',
	components: {
		NotificationBadge,
	},
	mixins: [AccountInfo, ModalHelper, ServiceHelper],
	props: {
		isMobile: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			enabled: 'enabled',
			requestTypes: null,
		}
	},
	computed: {
		accountDisplayName() {
			return this.account ? this.account.first_name + ' ' + this.account.last_name : '-'
		},
		accountRequestOpen() {
			return this.$store.state.misc.requestId != '' && this.$route.name.includes('requestCreateStep')
		},
		accountRequestText() {
			return this.accountRequestOpen ? this.$t('Navigation.RequestsComplete') : this.$t('Navigation.RequestsCreate')
		},
		isAccountNotCompleted() {
			return this.account && !this.account.completed
		},
		viewBox() {
			return this.isMobile ? '0 0 612 612' : '0 0 302 302'
		},
	},
	created() {
		if (sessionStorage.getItem('ius_request_types')) {
			// If available, use session request types
			this.requestTypes = JSON.parse(sessionStorage.getItem('ius_request_types'))
		} else {
			// Retrieve request types from API and store in session storage
			this.loadData()
		}
	},
	methods: {
		loadData() {
			// Get data
			axios
				.get('/request-types', {
					params: this.loadAllParams,
				})
				.then((response) => {
					this.requestTypes = response.data.info
					sessionStorage.setItem('ius_request_types', JSON.stringify(this.requestTypes))
				})
				.catch((error) => {
					console.log(error)
				})
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/header/HeaderNavigation.vue